import { createAsyncThunk } from "@reduxjs/toolkit";
import { getShareCartApiCallMagento } from "./share-cart.apis";
import { StoreState } from "../../store/store.interface";
import { getCustomerToken } from "../customer/customer";
import { getShopShareCartUrlMagento } from "../../common/utils/cart-util";
import { ActionStatus } from "../../common/constants/action-status";


/*----- DECLARE THUNKS ------*/

export const fetchShareCartId = createAsyncThunk('sharecart/getShareCartId', async (_: undefined, thunkAPI) => {
  const state = thunkAPI.getState() as StoreState;
  const customerToken = getCustomerToken(state);
  const url = getShopShareCartUrlMagento(state);
  return await getShareCartApiCallMagento(url, customerToken);
}, {
  condition: ((_arg, { getState }) => {
    const state = getState() as StoreState;
    if (state.shareCartState.status == ActionStatus.loading) {
      return false;
    }
    return true;
  })
});
